/*
    This is the root of the app where
    the store is configured and the
    app component is imported and made
    available.
*/

import React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'

import { store } from 'store'
import { history } from 'configureStore'
import { initMixpanel, initAppGlobals } from 'utils/tracker'

import Sugarcube from 'apps/sugarcube/Sugarcube'
import SugarcubeContext, { defaultContext } from 'apps/SugarcubeContext'
import { setUpCompositionPreFetch, setUpIFrameListener, getUrlContext } from 'apps/helpers'

import { fetchUser } from 'models/user/actions'
import { requestIkeaTokens } from 'models/tokens/actions'
// import { requestFavorites } from 'models/favorites/actions'
import { getIsIFrame, getSubCatalog, getResume } from 'models/location/selectors'
import { updateFurnitureFilter } from 'models/furniture/actions'
import { requestStatus } from 'models/support/actions'
import { loadCompositionFromLocalStorage } from 'models/localStorage/actions'

import OptimizelyProviderContainer from 'containers/OptimizelyProviderContainer'

import { openDesignSidepanel } from 'models/ui/actions'

import isMobile from 'utils/isMobile'

require('style/Root.scss')

const urlContext = getUrlContext()
const { isMagicWindow, isKiosk } = urlContext
const isInIframe = getIsIFrame()

initMixpanel()
initAppGlobals({ isMagicWindow, isDesignHome: isInIframe && !isMagicWindow, isKiosk })

setUpCompositionPreFetch(store)
setUpIFrameListener(store)

store.dispatch(requestStatus()) // Get backend status
// store.dispatch(requestFavorites())

const context = {
    ...defaultContext,
    ...urlContext,
    ikeaNav: isInIframe || urlContext.isKiosk,
    allowShare: !isInIframe,
    isMobile: isMobile(),
}

if (isInIframe) {
    // If we're in an iFrame, request a token
    // When the token comes back the
    // middleware will trigger a user fetch
    store.dispatch(requestIkeaTokens())
} else {
    // Otherwise fetch the user as normal
    store.dispatch(fetchUser())
}

if (!isMobile()) {
    store.dispatch(openDesignSidepanel())
}

if (getResume(store.getState())) {
    store.dispatch(loadCompositionFromLocalStorage())
}

// This will trigger a furniture request
const subCatalog = getSubCatalog(store.getState())
if (subCatalog) {
    store.dispatch(updateFurnitureFilter({ subCatalog }))
}

const Root = () => (
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <OptimizelyProviderContainer>
                <SugarcubeContext.Provider value={context}>
                    <Sugarcube />
                </SugarcubeContext.Provider>
            </OptimizelyProviderContainer>
        </ConnectedRouter>
    </Provider>
)

export default Root
